<script setup>
/**
 * The landing page for movement studios. Salons have their own, SalonsView.
 *
 * A flat list of sections. No grid-template-areas, no fixed heights — the old
 * version hard-coded .WhyApplates to 2570px on desktop and 5380px on mobile,
 * with the arithmetic done by hand in a comment.
 */
import TheNavbar from "../components/sections/TheNavbar.vue";
import HeroSection from "../components/sections/HeroSection.vue";
import ScheduleTicker from "../components/sections/ScheduleTicker.vue";
import LogoStrip from "../components/sections/LogoStrip.vue";
import ValueProps from "../components/sections/ValueProps.vue";
import HowItWorks from "../components/sections/HowItWorks.vue";
import FeatureShowcase from "../components/sections/FeatureShowcase.vue";
import IndustrySwitcher from "../components/sections/IndustrySwitcher.vue";
import TestimonialsSection from "../components/sections/TestimonialsSection.vue";
// Pricing is on hold until the real numbers land. To bring it back,
// uncomment this import, the <PricingSection /> below, and the "מחירים"
// entry in src/content/site.js.
// import PricingSection from "../components/sections/PricingSection.vue";
import FaqSection from "../components/sections/FaqSection.vue";
import LeadCaptureSection from "../components/sections/LeadCaptureSection.vue";
import TheFooter from "../components/sections/TheFooter.vue";
import MobileCtaBar from "../components/sections/MobileCtaBar.vue";
import { provideLanding } from "../composables/useLanding";
import { fitnessLanding } from "../content/landings/fitness";

provideLanding(fitnessLanding);
</script>

<template>
  <TheNavbar />

  <main id="main">
    <HeroSection />
    <ScheduleTicker />
    <ValueProps />
    <FeatureShowcase />
    <HowItWorks />
    <IndustrySwitcher />
    <!-- Who already runs on Applates, right before what they say about it. -->
    <LogoStrip />
    <TestimonialsSection />
    <!-- <PricingSection /> -->
    <FaqSection />
    <LeadCaptureSection />
  </main>

  <TheFooter />
  <MobileCtaBar />
</template>
